(function($) {
	// run fancy labels on load to deal with preloaded fields on Hubspot
	$(window).on('load',function(){
		fancyLabels($('.gfield input, .gfield textarea, .hs-form-field input, .hs-form-field textarea, .hs-dateinput input'));
	});	
	$(document).on('keyup input change','.gfield input, .gfield textarea, .hs-form-field input, .hs-form-field textarea, .hs-dateinput input',function(){
		fancyLabels($(this));
	});
  	$(document).on('gform_post_render', function(){
	    $('.gfield input, .gfield textarea').each(function(){
	    	fancyLabels($(this));
	    });
	    $('.gfield_radio, .gfield_checkbox, .ginput_container_select').each(function(){
	    	$(this).closest('.gfield').addClass('noFancy');
	    });
	});
	function fancyLabels(input) {
		console.log('running fancy labels');
		var val = input.val();
		if (val!='') {
			input.closest('.gfield, .hs-form-field').addClass('top');
		} else {
			input.closest('.gfield, .hs-form-field').removeClass('top');
		}
	}
	// disable previous dates for datepicker fields on GF
	if (typeof gform !== 'undefined') {
		gform.addFilter( 'gform_datepicker_options_pre_init', function( optionsObj, formId, fieldId ) {
		    optionsObj.minDate = 0;
		    return optionsObj;
		});
	}
	// open GN modals
	$('.gn-modal-opener').on('click',function(){
		$('.gn-modal-wrapper').fadeIn();
	});
	// close modal
	$('.gn-modal-wrapper').on('click',function(e){
		if($(e.target).hasClass('gn-modal-wrapper') || $(e.target).hasClass('close-btn') || $(e.target).closest('.close-btn').length) {
			$('.gn-modal-wrapper').fadeOut();
		}
	});
})( jQuery );
